// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTOneDriveDocument,
} from './';

/**
 * @export
 * @interface RESTRestoreToOriginalDocuments
 */
export interface RESTRestoreToOriginalDocuments {
    /**
     * Specifies IDs of the OneDrive documents that you want to restore. For more information on how to get such IDs, see [Get OneDrive Documents](#tag/OneDriveDocument/operation/OneDriveDocument_Get).
     * @type {Array<RESTOneDriveDocument>}
     * @memberof RESTRestoreToOriginalDocuments
     */
    documents?: Array<RESTOneDriveDocument>;
    /**
     * Specifies the action that will be performed in case the restore destination contains the restored documents.
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    documentAction?: RESTRestoreToOriginalDocumentsDocumentActionEnum;
    /**
     * Specifies the authentication code. For more information on how to get a device code, see [Get Device Code](#tag/RestoreSession/operation/RestoreSession_DeviceCodeAction). This property is required if you want to use a device code for data restore. 
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    userCode?: string;
    /**
     * Specifies the ID of the Microsoft Entra application that you want to use for restore.
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    applicationId?: string | null;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    applicationCertificatePassword?: string;
    /**
     * Specifies the SSL certificate configured for the Microsoft Entra application that you want to use for data restore. You must provide the certificate as a Base64 string.
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    applicationCertificate?: string;
    /**
     * Specifies the user name that you want to use for authenticating to the organization.
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    userName?: string;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    userPassword?: string;
    /**
     * Specifies the region of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    officeRegion?: RESTRestoreToOriginalDocumentsOfficeRegionEnum;
    /**
     * Specifies the name of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RESTRestoreToOriginalDocuments
     */
    organizationName?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreToOriginalDocumentsDocumentActionEnum {
    Overwrite = 'Overwrite',
    Keep = 'Keep'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreToOriginalDocumentsOfficeRegionEnum {
    Worldwide = 'Worldwide',
    Germany = 'Germany',
    China = 'China',
    UsDefence = 'USDefence',
    UsGovernment = 'USGovernment'
}

